export default __webpack_public_path__ + "static/media/nordik.82ced7e6.png";